import React, { useContext } from 'react';
import ThemeContext from 'shared/context/ThemeContext';
import debounce from 'lodash/debounce';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const DefaultFormButton = props => {
  const { handleLinkBtn, handleLinkAccount, error, showOTPConsents, activeOTPCheckbox } = props;
  const { FormButton } = useContext(ThemeContext);

  let disableButton = showOTPConsents && !activeOTPCheckbox;

  return (
    <div
      style={{
        ...FormButton.LinkBtn,
        ...(disableButton && { backgroundImage: `url(${require(asset`RoundedRect_Grey@2x.png`)}` }),
      }}
      onClick={debounce(() => {
        if (!error && !disableButton) handleLinkBtn(handleLinkAccount);
      }, 200)}
    >
      {getText(TEXT_KEY.LINK)}
    </div>
  );
};

export default DefaultFormButton;

